import { z } from 'zod';

/** A registered customer, or just an email and phone for a guest quote. */
export const customerSchema = z.object({
  customerId: z.string().nullable(),
  email: z
    .string()
    .trim()
    .refine((v) => v === '' || z.email().safeParse(v).success, {
      error: 'draftOrders:customer.validation.email',
    }),
  phone: z.string().trim().max(40, { error: 'draftOrders:customer.validation.phone' }),
});

export type CustomerFormInput = z.input<typeof customerSchema>;
export type CustomerFormOutput = z.output<typeof customerSchema>;
